import React from 'react';
import type { AppPromoLabel } from '@hero/schema';
import { AppLogo } from '../../../app/AppLogo';
import { AppPromoLabelBadge } from '../AppPromoLabelBadge';

export interface AppConnectBrandProps {
  name: string;
  logo: string;
  label?: AppPromoLabel;
  /** Short line under the name — e.g. connection status or app tagline. */
  subtitle?: string;
  /**
   * Drop the white tile behind the logo.
   *
   * The tile exists for logos that need a light backdrop to stay legible. A
   * mark that is already dark-on-transparent gains nothing from it and, on a
   * white surface, reads as a stray rounded square around the artwork.
   */
  bareLogo?: boolean;
  className?: string;
}

/**
 * Branded header for an app connect / settings modal — logo, name, optional promo badge.
 */
export function AppConnectBrand({
  name,
  logo,
  label,
  subtitle,
  bareLogo = false,
  className,
}: AppConnectBrandProps) {
  return (
    <div className={className}>
      <div className="flex items-center gap-3">
        <AppLogo name={name} logo={logo} compact={bareLogo} className="size-14 shrink-0" />
        <div className="min-w-0 flex-1">
          <p className="text-base font-semibold text-gray-900">{name}</p>
          {subtitle ? <p className="text-xs text-gray-500">{subtitle}</p> : null}
        </div>
        {label ? <AppPromoLabelBadge label={label} size="md" className="shrink-0" /> : null}
      </div>
    </div>
  );
}
